import { createTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import { ThemesTypes } from "./context";
import overrides from "./overrides";
import props from "./props";
import variables from "./variables";

const baseLightThemeColor = "#0f5381";
const baseDarkThemeColor = "#282a36";
const baseLacThemeColor = "#34B9D3";

const themes: { [key in ThemesTypes]: ReturnType<typeof createTheme> } = {
  light: createTheme({
    palette: {
      mode: "light",
      primary: {
        light: alpha(baseLightThemeColor, 0.3),
        main: baseLightThemeColor,
        dark: alpha(baseLightThemeColor, 0.7),
        contrastText: "#fff",
      },
      secondary: {
        light: alpha("#FFF", 0.3),
        main: "#FFF",
        dark: alpha("#FFF", 0.7),
        contrastText: baseLightThemeColor,
      },
    },
    components: {
      ...overrides,
      MuiCssBaseline: {
        styleOverrides: {
          ...variables,
        },
      },
    },
    variables,
    ...props,
  }),
  dark: createTheme({
    palette: {
      mode: "dark",
      primary: {
        light: alpha(baseDarkThemeColor, 0.3),
        main: baseDarkThemeColor,
        dark: alpha(baseDarkThemeColor, 0.7),
        contrastText: "#fff",
      },
      secondary: {
        light: alpha("#383a59", 0.3),
        main: "#383a59",
        dark: alpha("#383a59", 0.7),
        contrastText: "#fff",
      },
    },
    components: {
      ...overrides,
      MuiCssBaseline: {
        styleOverrides: {
          ...variables,
        },
      },
    },
    variables,
    ...props,
  }),
  lac: createTheme({
    palette: {
      mode: "light",
      primary: {
        light: alpha(baseLacThemeColor, 0.3),
        main: baseLacThemeColor,
        dark: alpha(baseLacThemeColor, 0.7),
        contrastText: "#fff",
      },
      secondary: {
        light: alpha("#ecaf0b", 0.3),
        main: "#ecaf0b",
        dark: alpha("#ecaf0b", 0.7),
        contrastText: "#fff",
      },
    },
    components: {
      ...overrides,
      MuiCssBaseline: {
        styleOverrides: {
          ...variables,
        },
      },
    },
    variables,
    ...props,
  }),
};

export default themes;
